import { render, staticRenderFns } from "./DiscountCreate.vue?vue&type=template&id=79b67420&"
import script from "./DiscountCreate.vue?vue&type=script&lang=js&"
export * from "./DiscountCreate.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCreate.vue?vue&type=style&index=0&id=79b67420&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports